<section class="content-header">
  <div class="container-fluid">
    <div class="card  ">
      <div class="card-header">
        @if (sessionProfile != PROFILES.INSTALADOR) {
          <app-panel-back
            class="panel-back-link"
          ></app-panel-back>
        }

        <h5>
          <b>{{ "activation" | translate }}</b>
        </h5>

        <!-- New button -->
        <app-material-panel-menu
          [onlyButton]="true"
          [icon]="saveIcon"
          [title]="saveTitle"
          (action)="activateMeter()"
          >
        </app-material-panel-menu>
      </div>

      <div #activationPanel class="card-body activation-panel">
        <!-- Location map -->
        <div class="activation-location-map">
          <app-map-controller
            [mapType]="mapType"
            [mapHeight]="mapHeight"
            [initialZoom]="initialZoom"
            [disableLegend]="true"
            [disableMeasure]="true"
            (meterNewLocation)="setNewLocation($event)"
            [disableCluster]="true"
            [searchAddress]="true"
            [hideMenu]="true"
            [gatewaysData]="[]"
            [metersData]="[activationData]"
            [zoomGameDeactivated]="true"
            >
            >
          </app-map-controller>

          <div class="activation-location-data">
            <!-- Latitude -->
            <mat-form-field
              class="activation-dialog-input-number"
              appearance="fill"
              >
              <mat-label>{{ "latitude" | translate }}</mat-label>
              <input
                matInput
                type="number"
                [(ngModel)]="activationData.latitude"
                step="0.01"
                min="-90"
                max="90"
                placeholder="{{ 'latitude' | translate }}..."
                (change)="updateMap()"
                />
            </mat-form-field>

            <!-- Longitude -->
            <mat-form-field
              class="activation-dialog-input-number"
              appearance="fill"
              >
              <mat-label>{{ "longitude" | translate }}</mat-label>
              <input
                matInput
                type="number"
                [(ngModel)]="activationData.longitude"
                step="0.01"
                min="-180"
                max="180"
                placeholder="{{ 'longitude' | translate }}..."
                (change)="updateMap()"
                />
            </mat-form-field>
          </div>
        </div>

        <!-- Activation data -->
        <div class="activation-data">
          <div class="activation-data-form">
            <div class="activation-data-inputs">
              <!-- Serial number -->
              <div class="activation-data-input">
                <mat-form-field appearance="fill">
                  <mat-label>
                    <span>{{ "serial-number" | translate }}</span>
                  </mat-label>
                  <input
                    matInput
                    [(ngModel)]="activationData.serialNumber"
                    maxlength="50"
                    placeholder="{{ 'serial-number' | translate }}..."
                    required
                    />
                </mat-form-field>
                <button
                  class="activaton-scan-button"
                  (click)="showScanner('serialNumber')"
                  >
                  <i class="fas fa-qrcode"></i>
                </button>
              </div>
              <!-- RF module -->
              <div class="activation-data-input">
                <mat-form-field appearance="fill">
                  <mat-label>
                    <span>{{ "rf-module" | translate }}</span>
                  </mat-label>
                  <input
                    matInput
                    [(ngModel)]="activationData.rfModule"
                    maxlength="50"
                    placeholder="{{ 'rf-module' | translate }}..."
                    />
                </mat-form-field>
                <button
                  class="activaton-scan-button"
                  (click)="showScanner('rfModule')"
                  >
                  <i class="fas fa-qrcode"></i>
                </button>
              </div>
              <!-- CUPS -->
              <div class="activation-data-input">
                @if (cupsName) {
                  <mat-form-field appearance="fill">
                    <mat-label>
                      <span>{{ cupsName }}</span>
                    </mat-label>
                    <input
                      matInput
                      [(ngModel)]="activationData.cups"
                      maxlength="50"
                      placeholder="{{ cupsName }}..."
                      />
                  </mat-form-field>
                }
              </div>
              <!-- Seal -->
              <div class="activation-data-input">
                <mat-form-field appearance="fill">
                  <mat-label>
                    <span>{{ "seal" | translate }}</span>
                  </mat-label>
                  <input
                    matInput
                    [(ngModel)]="activationData.seal"
                    maxlength="50"
                    placeholder="{{ 'seal' | translate }}..."
                    />
                </mat-form-field>
              </div>
            </div>
            <!-- Comments -->
            <div class="activation-data-comments">
              <mat-form-field appearance="fill">
                <mat-label>{{ "comments" | translate }}</mat-label>
                <textarea
                  matInput
                  rows="10"
                  [(ngModel)]="activationData.comments"
                  placeholder="{{ 'comments' | translate }}..."
                ></textarea>
              </mat-form-field>
              <button
                class="activaton-scan-button"
                (click)="showScanner('comments')"
                >
                <i class="fas fa-qrcode"></i>
              </button>
            </div>
          </div>
          <!-- Activation image -->
          <div class="activation-image">
            <div class="activation-image-load">
              <span>{{ "image" | translate }}</span>
              <div class="activation-image-search">
                <span class="btn btn-block btn-secondary btn-file">
                  <i class="fas fa-folder"></i>
                  <input
                    type="file"
                    id="file"
                    (change)="fileChangeEvent($event)"
                    accept="image/x-png,image/jpeg,image/ico"
                    />
                </span>
              </div>
              <div class="activation-image-search">
                <button class="btn" (click)="showCamera()">
                  <i class="fas fa-camera"></i>
                </button>
              </div>
            </div>
            @if (activationData.photos?.length > 0) {
              <div
                class="activation-photos"
                >
                @for (photo of activationData.photos; track photo; let i = $index) {
                  <div>
                    <img [src]="photo.image" />
                    <i class="fas fa-trash pointer" (click)="deletePhoto(i)"></i>
                  </div>
                }
              </div>
            }
          </div>
        </div>

        <!-- Reset -->
        <button class="activation-reset" (click)="resetData()">
          <i class="fa-solid fa-rotate-left"></i>
        </button>
      </div>
    </div>
  </div>
</section>
